import * as get from 'lodash/get';

/**
 * Util to power nested filter mappers and extractors
 * Takes a series expression to reach the first array and then will progress through properties to reach the desired value
 * Will return a default value if the desired path cannot be found
 * Check the tests for examples
 */
export class NestedFilterExtractorUtil {
	public static extractNestedProperty(
		storeData: object,
		seriesExpression: string,
		properties: NestedFilterExtractionProperty[],
		defaultValue?: any
	): any {
		const resultList: any[] = get(storeData, seriesExpression);
		if (resultList) {
			let previousResult = resultList;

			// Go through each values in the list and use recursion to reach the final value
			properties.forEach((pairToCompare: NestedFilterExtractionProperty) => {
				if (previousResult instanceof Array) {
					previousResult = get(previousResult.find(res =>
						get(res, pairToCompare.propertyToCompare) === pairToCompare.comparedValue), pairToCompare.desiredValueExpression, defaultValue);
				} else {
					previousResult = null; // If previous result is not an array but more arguments are given then something is wrong
				}
			});
			return previousResult;
		}
	}
}

export interface NestedFilterExtractionProperty { propertyToCompare: string; comparedValue: string | number; desiredValueExpression: string }
